import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = {};

const updateAll = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default createReducer(initialState, {
  [actionTypes.FETCH_TRANSLATIONS_SUCCESS]: updateAll,
});
